import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Music, Film, Camera, Award, Sparkles, Tv, Building2, Star, Users, Video } from "lucide-react";

const SERVICES = [
  { I: Music, l: "Music Video Casting", d: "Fashion-forward, cinematic casting for artist, label and independent music-video productions." },
  { I: Film, l: "Film & OTT Casting", d: "Actor casting for feature films, OTT originals, series and long-form storytelling." },
  { I: Camera, l: "Fashion & Commercial Casting", d: "Editorial, lookbook, campaign and commercial casting for premium fashion and lifestyle brands." },
  { I: Users, l: "Model Management", d: "End-to-end representation for models — bookings, negotiation, calendar and career development." },
  { I: Award, l: "Actor Casting", d: "Character casting for narrative projects, ads and branded storytelling." },
  { I: Sparkles, l: "Creator & Influencer Talent", d: "Curated creator collaborations for campaigns and content-first partnerships." },
  { I: Tv, l: "Brand Campaigns", d: "National and regional campaigns — talent sourcing, casting and shoot coordination." },
  { I: Video, l: "Digital Content Casting", d: "Social-first casting for shorts, reels, digital films and streaming content." },
  { I: Building2, l: "Talent Sourcing", d: "Fresh faces, city-specific requirements and audition-ready shortlists." },
  { I: Star, l: "Specialized Casting", d: "Dancers, athletes, twins, families and other specific casting briefs." },
];

export default function Services() {
  const [enq, setEnq] = useState({ name: "", email: "", requirement: "", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", { ...enq, phone: "", company: "" });
      toast.success("Enquiry sent. Our team will reach out shortly.");
      setEnq({ name: "", email: "", requirement: "", message: "" });
    } catch { toast.error("Could not send enquiry."); }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <section className="max-w-4xl mx-auto text-center px-4 pt-20 pb-8">
        <div className="sv-overline mb-4">Our Services</div>
        <h1 className="font-serif-hero text-4xl lg:text-7xl text-[#F4EFE4]">From casting to creation.</h1>
        <p className="mt-6 text-lg text-[#CDC7BA]">End-to-end talent, casting and production support across music, film, fashion, advertising and digital.</p>
      </section>

      <section className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {SERVICES.map((s) => (
            <div key={s.l} className="sv-card p-6 lg:p-8">
              <s.I className="text-[#C5A059] mb-4" />
              <div className="font-display-cinzel text-[13px] text-[#F4EFE4] mb-3">{s.l}</div>
              <p className="text-xs text-[#8A8478] leading-relaxed">{s.d}</p>
              <Link to="/contact" className="mt-6 inline-flex items-center gap-2 text-[10px] font-mono-label text-[#C5A059] hover:text-[#F4E4BC]">Enquire Now →</Link>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 py-16">
        <div className="sv-card p-8">
          <div className="sv-overline mb-3">Enquire</div>
          <h3 className="font-serif-editorial text-2xl text-[#F4EFE4] mb-6">Quick service enquiry</h3>
          <form onSubmit={submit} className="grid gap-3">
            <input required placeholder="Name" className="sv-input" value={enq.name} onChange={(e) => setEnq({ ...enq, name: e.target.value })} />
            <input required type="email" placeholder="Email" className="sv-input" value={enq.email} onChange={(e) => setEnq({ ...enq, email: e.target.value })} />
            <input placeholder="Service required" className="sv-input" value={enq.requirement} onChange={(e) => setEnq({ ...enq, requirement: e.target.value })} />
            <textarea required rows={4} placeholder="Brief" className="sv-input" value={enq.message} onChange={(e) => setEnq({ ...enq, message: e.target.value })} />
            <button className="sv-btn-primary">Submit Enquiry</button>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
}
